export const ResultContextDefaultData = {
	total_results: null,
	total_pages: null
}